const menuItems = document.querySelectorAll('.header-menu > li.menu-item-has-children');

new SV.HoverIntent(menuItems, {
    onEnter: function(targetItem) {
        targetItem.classList.add('visible');
        document.body.classList.add('menu-open');
    },
    onExit: function(targetItem) {
        targetItem.classList.remove('visible');
        document.body.classList.remove('menu-open');
    },

    exitDelay: 500,
    interval: 100,
    sensitivity: 7,
});

//# sourceMappingURL=hover-controls.js.map
